import { DaoModel } from '@dynameat/models';

export class FrontPrice extends DaoModel {
  constructor(guid, productGuid, productName, serviceGuid, date, price, previousPrice,
    maxPrice, minPrice) {
    super(guid);
    this.productGuid = productGuid || '';
    this.productName = productName || '';
    this.serviceGuid = serviceGuid || '';
    this.date = date || null;
    this.price = price || 0.0;
    this.previousPrice = previousPrice || 0.0;
    this.maxPrice = maxPrice || Number.POSITIVE_INFINITY;
    this.minPrice = minPrice || 0.0;
    this.oldValue = this.price;
  }

  static toInstance(props = {}) {
    return new FrontPrice(props.guid, props.product_guid, props.product_name, props.service_guid,
      props.date, props.price, props.previous_price, props.max_price, props.min_price);
  }

  serialize() {
    return {
      ...super.serialize(),
      product_guid: this.productGuid,
      product_name: this.productName,
      service_guid: this.serviceGuid,
      date: this.date,
      price: this.price,
      previous_price: this.previousPrice,
      max_price: this.maxPrice,
      min_price: this.minPrice,
    };
  }

  changePrice(newValue) {
    this.price = newValue;
  }

  hasChanged() {
    return this.price !== this.oldValue;
  }
}
